import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { fileUrl } from "@/components/UploadButton";

export default function About() {
  const { content } = useContent();
  const a = content.about_page || {};

  return (
    <div data-testid="about-page" className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
      {a.kicker && <p className="smallcaps mb-3">{a.kicker}</p>}
      <h1 className="font-display text-5xl sm:text-6xl text-[#212121] mb-12 max-w-3xl">
        {a.heading || "About"}
      </h1>

      <div className="grid md:grid-cols-2 gap-16">
        {a.image && <img src={fileUrl(a.image)} alt="" className="aspect-[4/5] object-cover border border-[#B2DFDB]" />}
        <div className="space-y-6 text-[#757575] leading-relaxed">
          {a.paragraph1 && <p>{a.paragraph1}</p>}
          {a.paragraph2 && <p>{a.paragraph2}</p>}
          {a.paragraph3 && <p>{a.paragraph3}</p>}
          {a.signature && <p className="text-[#212121] font-display text-2xl pt-4">{a.signature}</p>}
          <div className="pt-6">
            <Link to="/custom-order" className="btn-primary">Commission a piece</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-[#B2DFDB] mt-24 pt-16 grid sm:grid-cols-3 gap-12">
        {[1, 2, 3].map((n) => (
          <div key={n}>
            <p className="font-display text-5xl text-[#B87333] font-black mb-2">{a[`stat${n}_value`] || ""}</p>
            <p className="smallcaps">{a[`stat${n}_label`] || ""}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
